import { supertypeClass, property } from '@haventech/amorphic';
import { Person } from './Person';
import { Party } from './Party';
import { Phone } from './Phone';
import { Address } from './Address';
import { ESignSessionMetadata } from './ESignSessionMetadata';

@supertypeClass({ toClient: true, toServer: true })
export class Signer extends Person {
  @property({
    values: ['true', 'false'],
    descriptions: { true: 'Yes', false: 'No' },
    comment: "Is the signer the insured's legal guardian?",
  })
  isLegalGuardian: string;

  @property({
    rule: ['required'],
    comment: 'Is the Authorized Signer the sole officer?',
  })
  isSoleOfficer: string;

  @property({
    rule: ['required'],
    comment: "Authorized Signer's Title",
  })
  title: string;

  signingFor: Party;

  genderTrigger() {
    // does nothing, implemented so the genderTrigger in parent class (Person) does not run
  }

  emailTrigger() {
    if (this.signingFor) {
      this.signingFor.email = this.email;
    }

    // set insured's email = juvi's signer email
    if (this.isJuviSigner()) {
      this.customer.application.primaryPolicy.insured.person.email = this.email;
    }
  }

  isJuviSigner() {
    return (
      this.customer &&
      this.customer.application &&
      this.customer.application.primaryPolicy.insured &&
      this.customer.application.primaryPolicy.insured.signer === this
    );
  }

  constructor() {
    super();
  }

  static new(customer?) {
    return new Signer().init(customer);
  }

  init(customer?) {
    this.customer = customer;
    this.residentialAddress = Address.new(customer);
    this.phone = Phone.new(customer);
    this.esignMetadata = ESignSessionMetadata.new();
    return this;
  }
}
